import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';
import Value from './common/Value';

const styles = () => ({
  container: {
    margin: '16px 0px'
  },
  driverName: {
    margin: '8px 0px'
  },
  detailsContainer: {
    display: 'flex'
  }
});
const DriverDetails = ({ classes, driverData }) => {
  return (
    <div className={classes.container}>
      <Label labelText="Driver Details" />
      <Value
        value={`${driverData.driverName} #${driverData.driverNumber}`}
        customClasses={classes.driverName}
      />
      <div className={classes.detailsContainer}>
        <Detail label="Manifest #" value={driverData.manifestNumber} />
        <Detail label="Trailer #" value={driverData.trailerNumber} />
        <Detail label="Tractor #" value={driverData.tractorNumber} />
      </div>
    </div>
  );
};

export default withStyles(styles)(DriverDetails);
